import transformDateString from "../../helpers/transformDateString.mjs";
export const getValidationRules = (field) => {
  const rules = [];
  if (field.validations?.required) {
    const val = typeof field.validations.required === "object" ? true : field.validations.required;
    if (val === true)
      rules.push("required");
  }
  if (field.validations?.email) {
    const val = typeof field.validations.email === "object" ? true : field.validations.email;
    if (val === true)
      rules.push("email");
  }
  if (field.validations?.min) {
    const val = typeof field.validations.min === "object" ? field.validations.min.value : field.validations.min;
    if (typeof val === "number")
      rules.push(`min:${val}`);
  }
  if (field.validations?.max) {
    const val = typeof field.validations.max === "object" ? field.validations.max.value : field.validations.max;
    if (typeof val === "number")
      rules.push(`max:${val}`);
  }
  if (field.validations?.min_value) {
    const val = typeof field.validations.min_value === "object" ? field.validations.min_value.value : field.validations.min_value;
    if (typeof val === "number")
      rules.push(`min_value:${val}`);
  }
  if (field.validations?.max_value) {
    const val = typeof field.validations.max_value === "object" ? field.validations.max_value.value : field.validations.max_value;
    if (typeof val === "number")
      rules.push(`max_value:${val}`);
  }
  if (field.validations?.regex) {
    const val = typeof field.validations.regex === "object" ? field.validations.regex.value : field.validations.regex;
    if (val instanceof RegExp) {
      rules.push(`regex:${val.source}`);
    } else if (typeof val === "string") {
      rules.push(`regex:${val}`);
    }
  }
  if (field.validations?.numeric) {
    const val = typeof field.validations.numeric === "object" ? true : field.validations.numeric;
    if (val === true)
      rules.push("numeric");
  }
  if (field.validations?.one_of) {
    const val = typeof field.validations.one_of === "object" ? field.validations.one_of.value : field.validations.one_of;
    if (typeof val === "string")
      rules.push(`oneOf:${val}`);
    else if (Array.isArray(val))
      rules.push(`oneOf:${val.join(",")}`);
  }
  if (field.validations?.after) {
    const val = typeof field.validations.after === "object" ? field.validations.after.value : field.validations.after;
    if (typeof val === "string")
      rules.push(`after:${transformDateString(val)}`);
  }
  if (field.validations?.before) {
    const val = typeof field.validations.before === "object" ? field.validations.before.value : field.validations.before;
    if (typeof val === "string")
      rules.push(`before:${transformDateString(val)}`);
  }
  return rules.join("|");
};
export const getValidationMessages = (field) => {
  const messages = {};
  if (field.validations?.required && typeof field.validations.required === "object" && field.validations.required.error_message) {
    messages.required = field.validations.required.error_message;
  }
  if (field.validations?.email && typeof field.validations.email === "object" && field.validations.email.error_message) {
    messages.email = field.validations.email.error_message;
  }
  if (field.validations?.min && typeof field.validations.min === "object" && field.validations.min.error_message) {
    messages.min = field.validations.min.error_message;
  }
  if (field.validations?.max && typeof field.validations.max === "object" && field.validations.max.error_message) {
    messages.max = field.validations.max.error_message;
  }
  if (field.validations?.min_value && typeof field.validations.min_value === "object" && field.validations.min_value.error_message) {
    messages.min_value = field.validations.min_value.error_message;
  }
  if (field.validations?.max_value && typeof field.validations.max_value === "object" && field.validations.max_value.error_message) {
    messages.max_value = field.validations.max_value.error_message;
  }
  if (field.validations?.regex && typeof field.validations.regex === "object" && field.validations.regex.error_message) {
    messages.regex = field.validations.regex.error_message;
  }
  if (field.validations?.numeric && typeof field.validations.numeric === "object" && field.validations.numeric.error_message) {
    messages.numeric = field.validations.numeric.error_message;
  }
  if (field.validations?.one_of && typeof field.validations.one_of === "object" && field.validations.one_of.error_message) {
    messages.oneOf = field.validations.one_of.error_message;
  }
  if (field.validations?.after && typeof field.validations.after === "object" && field.validations.after.error_message) {
    messages.after = field.validations.after.error_message;
    messages.before = field.validations.after.error_message;
  }
  return messages;
};
const DEFAULT_LOCALE = "en";
const LOCAL_TO_VEE_LOCALES_MAP = {
  no: "en",
  pt: "en"
};
const getDefaultValidationMessages = async (veeValidateLocale, localLocale) => {
  const veeValidateMessages = await import(`vee-validate/dist/locale/${veeValidateLocale}.json`);
  const customRulesMessages = await import(`../locales/${localLocale}.json`);
  const validationMessages = {
    code: veeValidateMessages.default.code,
    messages: {
      ...veeValidateMessages.default.messages,
      ...customRulesMessages.default.messages
    }
  };
  return validationMessages;
};
export const setVeeValidateMessages = async (setMessagesByLocale, localeCode) => {
  const locale = localeCode || DEFAULT_LOCALE;
  const supposedVeeValidateLocale = LOCAL_TO_VEE_LOCALES_MAP[locale] || locale;
  try {
    const messages = await getDefaultValidationMessages(
      supposedVeeValidateLocale,
      locale
    );
    setMessagesByLocale(supposedVeeValidateLocale, messages);
  } catch (e) {
    console.warn(
      `[vee-validate] Locale "${supposedVeeValidateLocale}" not found. Falling back to "en"`
    );
    const fallbackMessages = await getDefaultValidationMessages(
      DEFAULT_LOCALE,
      DEFAULT_LOCALE
    );
    setMessagesByLocale(DEFAULT_LOCALE, fallbackMessages);
  }
};
